import { isNonNullable } from '@ori/ts-utils';
import { useAutoplay } from "./useAutoplay";
import { useKeyboard } from "./useKeyboard";
export var usePlugins = function usePlugins(props, setIsTouchActive) {
  var plugins = [useAutoplay(props, setIsTouchActive), useKeyboard(props)];
  return plugins.filter(isNonNullable);
};
//# sourceMappingURL=usePlugins.js.map